import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

// 引入Element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

// 引入全局样式
import '@/assets/global.scss'
// 引入项目样式
import '@/assets/css/style.css'
import '@/assets/css/lanrenzhijia.css'
import '@/assets/css/animate.min.css'
import '@/assets/css/wgdt.css'
import '@/assets/css/tanc.css'
// 引入 images 目录下的 CSS（如果存在）
try {
  require('@/assets/images/base.css')
} catch (e) {
  // 文件不存在时忽略
}
try {
  require('@/assets/images/home.css')
} catch (e) {
  // 文件不存在时忽略
}
try {
  require('@/assets/images/swiper-3.4.2.min.css')
} catch (e) {
  // 文件不存在时忽略
}

import 'animate.css/animate.css' // 确保引入 animate.css

// 引入并配置 WOW.js
import WOW from 'wowjs'
const wowInstance = new WOW.WOW({
  boxClass: 'wow',
  animateClass: 'animate__animated',
  offset: 30,
  mobile: true,
  live: false
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted() {
    setTimeout(() => {
      wowInstance.init();
    },100);
  }
}).$mount('#app')